import { render, staticRenderFns } from "./VolumeRecommendation.vue?vue&type=template&id=02e289da&scoped=true"
import script from "./VolumeRecommendation.vue?vue&type=script&lang=js"
export * from "./VolumeRecommendation.vue?vue&type=script&lang=js"
import style0 from "./VolumeRecommendation.vue?vue&type=style&index=0&id=02e289da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e289da",
  null
  
)

export default component.exports
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QTd from 'quasar/src/components/table/QTd.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QTable,QTr,QTh,QTd});
